<template>
  <svg class="icon" :width="size" :height="size">
    <use :href="iconName" />
  </svg>
</template>
<script>
import { ref } from 'vue'
export default {
  name:'SvgIcon',
  props:{
    iconName:{
      type: String,
      default: "",
      required: true
    },
    size:{
      type: Number,
      default: 24
    }
  },
  setup(props){
    return {
      size : ref(props.size),
      iconName: ref('#'+props.iconName)
    }
  }
}
</script>
